import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Pipe para procesar SVG y asegurar que hereden el color del texto
 */
@Pipe({
    name: 'svgColorInherit',
    standalone: true
})
export class SvgColorInheritPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(svg: string): SafeHtml {
        if (!svg) return '';
        
        // Asegurarse de que el SVG tenga fill="currentColor" si no lo tiene
        let processedSvg = svg;
        
        // Añadir fill="currentColor" al tag svg si no tiene fill
        if (!processedSvg.includes('fill=') && processedSvg.includes('<svg')) {
            processedSvg = processedSvg.replace('<svg', '<svg fill="currentColor"');
        }
        
        // Añadir fill="currentColor" a los elementos path, rect, etc. si no tienen fill
        const elements = ['path', 'rect', 'circle', 'ellipse', 'line', 'polyline', 'polygon'];
        elements.forEach(element => {
            const regex = new RegExp(`<${element}(?![^>]*fill=)`, 'g');
            processedSvg = processedSvg.replace(regex, `<${element} fill="currentColor"`);
        });
        
        return this.sanitizer.bypassSecurityTrustHtml(processedSvg); //NOSONAR
    }
} 